import endpoints from 'src/shared/service/endpoint/endpoints.class';
import { apiHead } from './common/api';

/*****************************************
 *
 * GET FUNCTIONS
 *
 *****************************************/

// Get liveness
export const apiHeadLiveness = async (): Promise<boolean> => {
  const endpointClass = endpoints.healthCheck.getLiveness;
  return apiHead(endpointClass.getUrl(), {
    publicApi: endpointClass.isPublic(),
    bypassManageError: false,
    withCredentials: false,
  })
    .then(() => Promise.resolve(true))
    .catch(() => Promise.resolve(false));
};
